
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.7 12.7","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1.058 -282.712)"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","transform":"matrix(.26458 0 0 .26458 2.117 283.77)","fill":"#041e42"}}),_c('path',{attrs:{"d":"M7.408 285.887c-1.11 0-2.116.9-2.116 2.011 0 1.112.918 2.437 2.116 4.34 1.2-1.902 2.117-3.228 2.117-4.34 0-1.11-1.005-2.01-2.117-2.01zm0 2.91a.794.794 0 11.794-.793.794.794 0 01-.794.794z","fill":"#e72122"}})])])
          )
        }
      }
    